import { TutorialStepConfig } from "@/types/tutorial";

export const tutorialSteps: TutorialStepConfig[] = [
  {
    id: "welcome",
    type: "fullscreen",
    title: "Bem-vindo à Planific! 🎉",
    description:
      "Sua jornada para o controle financeiro inteligente começa aqui. Vamos fazer um tour rápido pelas principais funcionalidades da plataforma.",
    icon: "Sparkles",
  },
  {
    id: "dashboard-header",
    type: "spotlight",
    targetSelector: ".dashboard-header > .space-y-3",
    position: "bottom",
    title: "Visão Geral do Dashboard",
    description:
      "Este é seu painel de controle. Aqui você encontra os filtros de período e o botão para incluir e excluir lançamentos futuros em suas análises.",
    icon: "LayoutDashboard",
  },
  {
    id: "period-filter",
    type: "spotlight",
    targetSelector: "#period-filter",
    position: "bottom",
    title: "Filtros de Período",
    description:
      "Visualize suas finanças por dia, semana, mês ou ano. Você também pode navegar entre períodos usando as setas ao lado.",
    icon: "Calendar",
  },
  {
    id: "include-futures",
    type: "spotlight",
    targetSelector: "#include-futures-container",
    position: "bottom",
    title: "Incluir Lançamentos Futuros",
    description:
      "Ative esta opção para visualizar projeções futuras em seus gráficos e estatísticas. Ideal para planejamento financeiro!",
    icon: "ToggleRight",
  },
  {
    id: "stats-cards",
    type: "spotlight",
    targetSelector: ".dashboard-stats",
    position: "bottom",
    title: "Estatísticas em Tempo Real",
    description: "Acompanhe saldo, receitas, despesas e economia ou lucro do período selecionado nos filtros.",
    icon: "TrendingUp",
  },
  {
    id: "cash-flow-chart",
    type: "spotlight",
    targetSelector: '[id="cash-flow-chart"]',
    position: "top",
    title: "Gráfico de Fluxo de Caixa",
    description:
      "Visualize a evolução das suas receitas, despesas e saldo ao longo do tempo. Identifique tendências e tome decisões informadas.",
    icon: "LineChart",
  },
  {
    id: "expense-chart",
    type: "spotlight",
    targetSelector: "#expense-chart",
    position: "top",
    title: "Análise de Despesas",
    description:
      "Veja para onde seu dinheiro está indo. Este gráfico mostra suas despesas organizadas por categoria, facilitando identificar oportunidades de economia e controle de gastos.",
    icon: "PieChart",
  },
  {
    id: "goals-progress",
    type: "spotlight",
    targetSelector: "#goals-progress",
    position: "top",
    title: "Progresso das Metas",
    description: "Acompanhe suas metas financeiras. Defina objetivos, prazos e veja seu progresso em tempo real.",
    icon: "Target",
  },
  {
    id: "add-transaction-button",
    type: "spotlight",
    targetSelector: "#add-transaction-btn",
    position: "left",
    title: "Adicione Suas Transações",
    description: `Este é o coração da Planific! Clique no botão "+" para registrar suas transações financeiras.

O que você pode registrar:
• 💰 Receitas e despesas
• 💳 Pagamentos com cartão
• 🏦 Transferências entre contas
• 📊 Parcelamentos automáticos

Obs: Lembre-se de marcar o status da transação, se pago ou pendente!

Após concluir o tutorial, clique no botão "+" para começar!`,
    icon: "PlusCircle",
  },
  {
    id: "sidebar-transacoes",
    type: "spotlight",
    targetSelector: '[data-tutorial-id="sidebar-transacoes"]',
    position: "right",
    title: "Página de Transações",
    description: "Acesse todas as suas transações com filtros avançados por data, categoria, conta e muito mais.",
    icon: "ArrowLeftRight",
  },
  {
    id: "sidebar-lancamentos",
    type: "spotlight",
    targetSelector: '[data-tutorial-id="sidebar-lancamentos"]',
    position: "right",
    title: "Lançamentos Futuros",
    description:
      "Planeje pagamentos recorrentes e futuros. Mantenha controle sobre o que está por vir e nunca mais esqueça uma conta.",
    icon: "Clock",
  },
  {
    id: "sidebar-contas",
    type: "spotlight",
    targetSelector: '[data-tutorial-id="sidebar-contas"]',
    position: "right",
    title: "Gerenciar Contas",
    description: "Cadastre e gerencie suas contas bancárias. Acompanhe saldos conta à conta e organize suas finanças.",
    icon: "Landmark",
  },
  {
    id: "sidebar-cartoes",
    type: "spotlight",
    targetSelector: '[data-tutorial-id="sidebar-cartoes"]',
    position: "right",
    title: "Cartões de Crédito",
    description: "Controle seus cartões de crédito, limites disponíveis e faturas.",
    icon: "CreditCard",
  },
  {
    id: "sidebar-categorias",
    type: "spotlight",
    targetSelector: '[data-tutorial-id="sidebar-categorias"]',
    position: "right",
    title: "Categorias Personalizadas",
    description: "Organize transações em categorias personalizadas. Entenda melhor para onde vai seu dinheiro.",
    icon: "FolderTree",
  },
  {
    id: "sidebar-relatorios",
    type: "spotlight",
    targetSelector: '[data-tutorial-id="sidebar-relatorios"]',
    position: "right",
    title: "Relatórios Detalhados",
    description:
      "Análises profundas com gráficos e métricas avançadas. Visualize tendências e tome decisões estratégicas.",
    icon: "BarChart3",
  },
  {
    id: "sidebar-orcamentos",
    type: "spotlight",
    targetSelector: '[data-tutorial-id="sidebar-orcamentos"]',
    position: "right",
    title: "Orçamentos",
    description: "Defina orçamentos mensais por categoria e acompanhe seus gastos. Evite surpresas no fim do mês.",
    icon: "PiggyBank",
  },
  {
    id: "sidebar-metas",
    type: "spotlight",
    targetSelector: '[data-tutorial-id="sidebar-metas"]',
    position: "right",
    title: "Metas Financeiras",
    description: "Estabeleça metas financeiras claras e acompanhe seu progresso. Alcance seus objetivos passo a passo.",
    icon: "Target",
  },
  {
    id: "conclusion",
    type: "fullscreen",
    title: "Você Está Pronto! 🚀",
    description:
      "Agora que conhece todas as ferramentas, é hora de colocar em prática! Comece registrando suas primeiras transações e explore todos os recursos. Você pode acessar este tutorial novamente em Configurações.",
    icon: "CheckCircle",
  },
];
